/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for POST /enroll/estimate — how many credits the cohort will cost.
 */
export interface EnrollmentRevealEstimateRequest {
  /**
     * @minItems 1
     * @maxItems 50
     */
  job_candidate_ids: string[];
}
